module.exports = __webpack_public_path__ + "static/media/about-12.93f6e960.jpg";